// Auto-generated normalizer for table: CAR_BOOKING.ExcepcionTurno
export function excepcionTurnoNormalize(row) {
  return {
    idExcepcion: row.idExcepcion ?? row.IdExcepcion ?? row['idExcepcion'] ?? 0,
    idChofer: row.idChofer ?? row.IdChofer ?? row['idChofer'] ?? 0,
    nombreExcepcion: row.nombreExcepcion ?? row.NombreExcepcion ?? row['nombreExcepcion'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['descripcion'] ?? '',
    fechaInicio: row.fechaInicio ?? row.FechaInicio ?? row['fechaInicio'] ?? null,
    horaInicio: row.horaInicio ?? row.HoraInicio ?? row['horaInicio'] ?? '',
    horaFin: row.horaFin ?? row.HoraFin ?? row['horaFin'] ?? '',
    fechaFin: row.fechaFin ?? row.FechaFin ?? row['fechaFin'] ?? null,
    motivo: row.motivo ?? row.Motivo ?? row['motivo'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null
  };
}